<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="col-md-12">
          <ol class="breadcrumb breadcrumb-card-header pull-left">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);" @click="backParent"> Bank</a>
            </li>
            <li class="breadcrumb-item active">
              <span v-if="bank.id === null">New</span>
              <span v-else>
                {{ bank.name }}
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group row">
              <label for="group_id" class="col-sm-3 col-form-label text-left">Bank Group</label>
              <div class="col-sm-9">
                <select v-model="bank.group_id" class="form-control">
                  <option v-for="o in bankGroupList" :key="o.id" :value="o.id">{{ o.name }}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="account_no" class="col-sm-3 col-form-label text-left">Account Number</label>
              <div class="col-sm-9">
                <input type="text" v-model="bank.account_no" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="bank.name" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="company_no" class="col-sm-3 col-form-label text-left">Company</label>
              <div class="col-sm-9">
                <select v-model="bank.company_no" class="form-control">
                  <option v-for="c in companyList" :key="c.company_no" :value="c.company_no">{{ c.name }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label for="address" class="col-sm-3 col-form-label text-left">Address</label>
              <div class="col-sm-9">
                <textarea rows="5" v-model="bank.address" class="form-control"></textarea>
              </div>
            </div>
            <div class="form-group row">
              <label for="phone" class="col-sm-3 col-form-label text-left">Phone</label>
              <div class="col-sm-9">
                <input type="text" v-model="bank.phone" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="email" class="col-sm-3 col-form-label text-left">Email</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" v-model="bank.email"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="email" class="col-sm-3 col-form-label text-left">Account</label>
              <div class="col-sm-9">
                <select v-model="bank.account_code" class="form-control">
                  <option v-for="a in getAccount" :key="a.id" :value="a.account_code">[{{ a.account_code}}] {{ a.account_name }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
        <button type="button" @click="createBank" class="btn btn-sm btn-primary pull-right" v-if="bank.id === null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
        <button type="button" @click="updateBank" class="btn btn-sm btn-primary pull-right" v-else><i class="fa fa-save" aria-hidden="true"></i> Update</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { getHeader, bankUrl } from '../../config'

export default {
  name: 'BankForm',
  props: ['bank'],
  computed: {
    ...mapState({
      bankGroupList: state => state.bankGroups.bankGroupList,
      accountList: state => state.accounts.accountList,
      companyList: state => state.companies.companyList
    }),
    getAccount: function () {
      return this.accountList
    }
  },
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    async updateBank () {
      await axios.put(bankUrl + '/' + this.bank.id, this.bank, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          this.$swal(
            'Error',
            '<pre>' + error.response + '</pre>',
            'error'
          )
        })
    },
    async createBank () {
      await axios.post(bankUrl, this.bank, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          this.$swal(
            'Error',
            '<pre>' + error.response + '</pre>',
            'error'
          )
        })
    }
  }
}
</script>
